module.exports = __webpack_public_path__ + "static/index/img/baikal-701.10824817.jpg";